import {
  post,
  put,
  get,
  del
} from '../configApi'
export async function getUserGroup(params = null) {
  return await get(`/usergroup/list`, params)
}
export async function getUserGroupAdmin() {
  return await get(`/usergroup/list/admin`)
}
export async function insertUserGroup(body) {
  return await post(`/usergroup/manage/insert`, body)
}
export async function updateUserGroup(body) {
  return await put(`/usergroup/manage/update`, body)
}
export async function deleteUserGroup(body) {
  return await del(`/usergroup/manage/delete`, body)
}

export async function setRootUserGroup(body) {
  return await put(`/usergroup/manage/setpriority`, body)
}
export async function setUserGroup(body) {
  return await put(`/usergroup/manage/setgroup`, body)
}
export async function setActiveUserGroup(body) {
  return await put(`/usergroup/manage/setgroup`, body)
}
export async function updateActiveUserGroup(body) {
  return await put(`/usergroup/manage/active`, body)
}



export async function getlistCompany() {
  return await get(`/company/list/admin`)
}
export async function getUserGroupCompany() {
  return await get(`/company/usergroup/list`)
}
export async function getDetailCompany(body) {
  return await get(`/course/detail/company/admin`, body)
}
export async function setDetailCompany(body) {
  return await put(`/course/manage/setcompany`, body)
}
export async function setUserGroupToCourse(body) {
  return await put(`/course/manage/setusergroup`, body)
}
export async function setUserGroupToCourseByAdmin(body) {
  return await put(`/course/manage/setusergroup/admin`, body)
}
